import React from 'react'
import { Grid, useMatchBreakpoints,Text, Flex } from '@crystals/uikit'
import styled from 'styled-components'
import Container from '../../../components/layout/Container'

const Footer = styled.div`
  background-color: #07071c;
`

const Line =styled.div`
  width: 90%;
  border-top: 1px solid rgba(255, 255, 255, 0.2) ;
`

const SmallText = styled(Text)`
    // max-width: 768px;
    font-family: 'fs', sans-serif;
    color: #00e0b8;
    font-size: 20px;
    line-height: 1.5;
`

const FooterSection: React.FC = () => {

  const { isXl } = useMatchBreakpoints()
  const isMobile = !isXl
    return(
      <Footer>
        <Container>
          <Flex justifyContent="center" alignItems="center">
            <Line />
          </Flex>
          <Flex>
            <div style={{padding:isMobile?"0px 10px":"0px 120px", color:"rgb(69 105 110)", marginTop:"50px", lineHeight:"1.5", fontWeight:200}}>
              This website is a fun game on Polygon and we want all of our players to play responsibly. Please only play Matic you are comfortable parting with that won’t impact your well-being. This website is not responsible for any losses you may have
            </div>              
          </Flex>
          <Grid
            gridTemplateColumns={isMobile ? '1fr' : '1fr 1fr 1fr'}
            gridColumnGap={isMobile ? '0' : '30px'}
            gridRowGap={isMobile ? '45px' : '0'}
            pt={isMobile ? '77px' : '56px'}
            pb={isMobile ? '77px' : '56px'}
          >
            <div style={{ alignItems: "center", textAlign: "center" }}>
              <img src={`${process.env.PUBLIC_URL}/images/landing/aito/footer/telegram.svg`} style={{ width: "30px", marginRight: "10px" }} alt="alitura" />              
            </div>
            <div style={{ alignItems: "center", textAlign: "center" }}>
                <SmallText>
                  Shine CoinFlip
                </SmallText>
            </div>
            <div style={{ alignItems: "center", textAlign: "center", color: "#fff"}}>              
                Copyright © year OUR TEAM
            </div>
          </Grid>
          
        </Container>
      </Footer>
    )
}

export default FooterSection